module.exports = __webpack_public_path__ + "static/media/07.30ad8c23.jpg";